import lodashDebounce from 'lodash.debounce'

function debounce<T extends (...args: any) => any>(func: T) {
  return lodashDebounce(func, 2_000, { leading: true, trailing: false })
}

export default debounce
